module.exports = __webpack_public_path__ + "static/6-aae664755bd575fa2bf5a81f77d9a009.png";